import { Button, Modal, Row, Space } from 'antd';
import React, { useCallback, useEffect, useState } from 'react';
import { BiUpload } from 'react-icons/bi';
import { trackPromise, usePromiseTracker } from 'react-promise-tracker';
import { useLocation } from 'react-router-dom';
import { ICommonState, IFileUploads } from '../../../../../model/CommonModel';
import { useCommonStore } from '../../../../../stores/CommonStore';
import { useOperationStore } from '../../../../../stores/OperationStore';
import { emptyUploadedFileValue } from '../../../../../stores/common';
import { ERROR, FILE_SIZE_EXCEEDS, MARKEN_FILE, TWO_MB_TO_BYTES, TWO_HUNDRED_SUCCESS_CODE, fileToBase64 } from '../../../../../utils/app-common';
import LoadingModalComponent from '../../../../CommonComponent/LoadingModalComponent';
import ImageRenderComponent from './ImageRenderComponent';

type Props = {
    open: boolean,
    onClose: (value: boolean) => void,
}

const FileComponent = ({ open, onClose }: Props) => {
    const { state } = useLocation() || {};
    const { waybillNo, id } = state || {};
    const { promiseInProgress: fileUploadProgress } = usePromiseTracker(({ area: 'file-upload-area' }));

    const UploadFileAction = useOperationStore((state) => state.UploadFileAction);

    const onChange = useCallback((event: React.ChangeEvent<HTMLInputElement>) => {
        const [files] = (event.target as HTMLInputElement).files || [];
        if(files?.size > TWO_MB_TO_BYTES){
            Modal.error({
                title: ERROR,
				closable: true,
                content: FILE_SIZE_EXCEEDS,
                onOk: () => Modal.destroyAll()
            });
            return
        }
        const reader = fileToBase64(files)
        reader.onload = () => {
            const request: IFileUploads = {
                attachmentList: [{
                    wayBillNumber: waybillNo,
                    attachmentDataString: (reader.result?.toString())?.split(',')[1] || '',
                    fileFormat: files?.type?.split('/')?.at(1),
                    fileType: MARKEN_FILE,
                    category: 'booking',
                    categoryId: id,
                }]
            };
            trackPromise(UploadFileAction(request, waybillNo), 'file-upload-area')
        };
        reader.onerror = error => {
            console.error("Error: ", error);
        };

    }, [UploadFileAction, id, waybillNo]);


    return (
        <Modal maskClosable={false} open={open} width={500} onOk={() => onClose(false)} onCancel={() => onClose(false)} title='File Upload'>
            <LoadingModalComponent isLoading={fileUploadProgress}>
                <Row>
                    <input className='upload'
                        type='file'
                        onChange={onChange}
                        onClick={emptyUploadedFileValue}
                        placeholder='UploadFile' />
                </Row>
            </LoadingModalComponent>
        </Modal>
    )
}


const FileUploadComponent = () => {
    const { state } = useLocation() || {};
    const { waybillNo } = state || {};

    const markenFiles = useCommonStore(state => state.markenFiles);
    const GetMarkenFilesListAction = useCommonStore((state: ICommonState) => state?.GetMarkenFilesListAction);

    const { promiseInProgress } = usePromiseTracker(({ area: 'files-list-area' }));

    const [isOpen, setIsOpen] = useState(false);
    const fileUploadResponse = useOperationStore((state) => state.fileUploadResponse);

    useEffect(() => {
        if (fileUploadResponse && fileUploadResponse === TWO_HUNDRED_SUCCESS_CODE) {
            setIsOpen(false)
            useOperationStore.setState({ fileUploadResponse: undefined })
        }
        trackPromise(GetMarkenFilesListAction(waybillNo), 'manifest-file-area');
    }, [fileUploadResponse])
    return (
        <>
            <LoadingModalComponent isLoading={promiseInProgress}>
                <>
                    <Row justify='space-between'>
                        <Space size={5}>
                            <Button icon={<BiUpload size={18} />} className='icon-button' onClick={() => setIsOpen(true)}
                            >
                                Upload File
                            </Button>
                            {/* <Button icon={<BiRefresh size={18} />} className='icon-button' onClick={onRefreshHandler}></Button> */}
                        </Space>
                    </Row>
                    {!promiseInProgress && (<>
                        <Space wrap direction='vertical' size={[20, 20]}>
                            <ImageRenderComponent list={markenFiles} label={"Marken Files"} />
                        </Space>
                    </>)
                    }
                </>
            </LoadingModalComponent>
            {isOpen ? <FileComponent open={isOpen} onClose={(prev) => setIsOpen(prev)} /> : null}
        </>
    )
}

export default FileUploadComponent